module.exports = __webpack_public_path__ + "static/img/jiayongdianqi.8ccc978.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/type/daohang/jiayongdianqi.png
// module id = GKAS
// module chunks = 12